module.exports = __webpack_public_path__ + "pcnz/img/mother-2.f483e952.jpg";